import { IBase } from '@/models/base-model';

export const parseBase = (base?: IBase) => {
  if (base?.name && base?.code) return `${base?.name} (${base?.code})`;
  if (base?.name) return `${base?.name}`;
  if (base?.code) return `${base?.code}`;
  return `N/A`;
};
